import service from '@/utils/request'

// 查询事业部
export const useOrgListApi = () => {
	return service.get('/sys/org/list')
}

export const useOrgApi = (id: Number) => {
	return service.get('/sys/org/' + id)
}

export const useOrgNameListApi = (idList: number[]) => {
	return service.post('/sys/org/nameList', idList)
}

export const useOrgSubmitApi = (dataForm: any) => {
	if (dataForm.id) {
		return service.put('/sys/org', dataForm)
	} else {
		return service.post('/sys/org', dataForm)
	}
}

export const useOrgDeleteApi = (key: any) => {
	return service.delete('/sys/org/' + key)
}
